import { Injectable } from '@angular/core';
import { ModelActionsModal } from '@models-global/model-actions';
import { ReportType } from '@module-report/enums/report-type.enum';
import { Action, State, StateContext } from '@ngxs/store';
import { ActionClaimModalGenerateReport } from './claims-modal.actions';

export interface StateClaimModal {
  readonly value: ReportType | undefined;
  readonly action: ModelActionsModal | undefined;
}

@State<StateClaimModal>({
  name: 'StateClaimModal',
  defaults: {
    value: undefined,
    action: undefined
  }
})
@Injectable()
export class ClaimsModalState {
  @Action(ActionClaimModalGenerateReport)
  generateReport(
    ctx: StateContext<StateClaimModal>,
    action: ActionClaimModalGenerateReport
  ): void {
    const state = ctx.getState();
    ctx.patchState({
      ...state,
      value: action.value,
      action: action.action
    });
  }
}
